import { Component, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Items, Menu } from '../../api/menu';
import { StyleClassModule } from 'primeng/styleclass';

@Component({
  selector: 'app-sidebar-item',
  standalone: true,
  imports: [RouterModule, TranslateModule, StyleClassModule],
  templateUrl: './sidebar-item.component.html',
  styleUrl: './sidebar-item.component.scss'
})
export class SidebarItemComponent {
  public translate = inject(TranslateService);

  @Input() item!: Menu;
}
